function tz() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export { tz }
